module.exports = __webpack_public_path__ + "static/postman-96d3633941a31ce2303a2240fb5beb21.png";